import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import { observer } from 'mobx-react';
import { useRouter } from 'next/router';

import { isWeightedProduct } from 'shared/helpers/products';

import { groupOptionsWithPrices } from 'utils/helpers/product';
import useCart from 'src/hooks/use-cart';
import useUI from 'src/hooks/use-ui';

import useViewportVisibility from 'hooks/use-viewport-visibility';

import DesktopProductListItem from './desktop-product-list-item';
import MobileProductListItem from './mobile-product-list-item';

const ProductListItem = ({ product, productIndex, isMobile, onClick, onAddToCart, onProductView }) => {
  const { ref, hasBeenVisible } = useViewportVisibility();

  const { menuType } = useCart();
  const UI = useUI();
  const { isKiosk } = UI;

  const showTAC = !_.isEmpty(product?.cannabinoidsV2);

  const router = useRouter();
  const viewingOffersPage = _.includes(router.route, 'specials/offer');
  const { specialId } = router.query;

  const hasStrainType = product.strainType && product.strainType !== 'N/A';
  const parsedOptions = groupOptionsWithPrices({
    product,
    menuType,
    isKiosk,
    offerSpecial: viewingOffersPage,
    specialId,
  });

  const weightedProduct = isWeightedProduct(product);

  const handleAddToCart = (option) => {
    onAddToCart(product, productIndex, option);
  };

  const handleClick = () => {
    onClick(product, productIndex);
  };

  const onProductViewRef = useRef(onProductView);

  useEffect(() => {
    if (hasBeenVisible) {
      onProductViewRef.current?.(product, productIndex);
    }
  }, [product, productIndex, hasBeenVisible]);

  const ListItem = isMobile ? MobileProductListItem : DesktopProductListItem;

  return (
    <ListItem
      hasBeenVisible={hasBeenVisible}
      ref={ref}
      product={product}
      hasStrainType={hasStrainType}
      parsedOptions={parsedOptions}
      weightedProduct={weightedProduct}
      onAddToCart={handleAddToCart}
      onProductClick={handleClick}
      showTAC={showTAC}
      addButtonEnabled
    />
  );
};

export default observer(ProductListItem);
